export default "/images/vendor/flag-icon-css/flags/1x1/kz.svg?f528d1705766032d823749be521ec653";